import { Dropdown } from './dropdown.component.js';

export * from './dropdown.component.js';
export default Dropdown;

Dropdown.define('der-ui-dropdown');

declare global {
    interface HTMLElementTagNameMap {
        'der-ui-dropdown': Dropdown;
    }
}
